export const CONTENT_CHANGE_EVENT = 'contentchange';
